import styled from "styled-components";

export const CardOrdenDigitalContainer = styled.div`
  border-radius: 16px;
  width: 332px;
  /* height: 390px; */
  box-shadow: 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198),
    0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275),
    0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035),
    0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725),
    0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);
`;
export const CardOrdenDigitalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(257.94deg, #027bc0 18.65%, #004b76 86.55%);
  color: var(--color-white);
  /* height: 46px; */
  border-radius: 16px 16px 0 0;
  padding: 10px 0 10px 20px;
`;
export const CardOrdenDigitalBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
export const CardOrdenDigitalDatos = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
  /* height: 210px; */
  .ordenDigital-direccion {
    text-decoration: underline;
    color: var(--color-latex30);
    cursor: pointer;
  }
`;
export const CardOrdenDigitalMensaje = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: ${({ $flgOrdenAsociada, $cancelado }) =>
    `${$flgOrdenAsociada && !$cancelado ? "var(--color-broccoli)" : "var(--color-danger)"}`};
`;
export const CardOrdenDigitalBotones = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
  /* height: 120px; */
  /* margin-top: 14px; */
`;
export const CardOrdenDigitalBoton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  height: 38px;
  color: var(--color-white);
  cursor: pointer;
`;
export const CardOrdenDigitalBotonOutl = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  height: 38px;
  cursor: pointer;
  color: var(--color-latex30);
  border: 2px solid var(--color-latex30);
`;
export const CardOrdenDigitalBotonOutline = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: max-content;
  padding: 16px 20px;
  gap: 20px;
  border-radius: 8px;
  height: 38px;
  color: var(--color-latex30);
  margin: auto;
  margin-top: 24px;
  margin-bottom: 14px;
  cursor: pointer;
  border: 2px solid var(--color-latex30);
`;
